import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import { useState } from "react";
import React, { Component }  from 'react';
import SignatureCanvas from "react-signature-canvas";

export interface props {
  open: boolean;
  onClose: (value: string) => void;
  handleProgress: (value: string) => void;
}

export default function AssinaturaManuscritoDialog(props: props) {
  //modal control
  const { onClose, open } = props;
  const { handleProgress} = props;
  const handleClose = () => {
    onClose("");
    setDisabled(true);
  };

  //sign control
  const [sign, setSign] = useState<SignatureCanvas | null>(null);
  const [isSign, setIsSign] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);

  const clearHandler = () => {
    if (sign) {
      sign.clear();

      setIsSign(false);
    }
  };
  
  const capturarHandler = () => {
    //set base64 signature
    if (sign) {
      onClose(sign.getTrimmedCanvas().toDataURL("image/png"));
      console.log(sign.getTrimmedCanvas().toDataURL("image/png") , "IMAGEM DA ASSINATURA")
      
      handleProgress(sign.getTrimmedCanvas().toDataURL("image/png"))
     
      // onClose(sign.toDataURL("image/png"));
      
    }
  };

  //get REF from SignatureCanvas
  const getSignFromCanvas = (ref: any) => {
    setSign(ref);
  };

  return (
    <Dialog open={open}>
      <DialogTitle>Assinatura Manuscrito Digital</DialogTitle>

      <DialogContent style={{padding: 10}}>
        <SignatureCanvas
          penColor="black"
          onEnd={() => setIsSign(true)}
          canvasProps={{ width: 250, height: 38, style: {border: '1px solid #cecece', marginRight: 'auto', marginLeft: 'auto', display: 'block'}, className: "sigCanvas" }}
          ref={(ref: SignatureCanvas | null) => {
            getSignFromCanvas(ref);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={capturarHandler}
          disabled={isSign ?  false : true}
        >
          Assinar
        </Button>
        <Button variant="outlined" onClick={clearHandler}>
          Limpar
        </Button>
        <Button variant="outlined" onClick={handleClose}>
          Fechar
        </Button>
      </DialogActions>
      
    </Dialog>
    
  );
}

const useStyles = makeStyles((theme) => ({
  signArea: {},
  btnFechar: {},
}));
